import { render, staticRenderFns } from "./TherapistProduction.vue?vue&type=template&id=ae83e866"
import script from "./TherapistProduction.vue?vue&type=script&lang=js"
export * from "./TherapistProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports